var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRouteDivert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27051_371105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16Z",
    fill: "url(#paint0_linear_27051_371105)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_27051_371105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3331 19.8331C21.3331 20.4999 20.3331 20.4999 20.3331 19.8331C20.3331 19.1668 21.3331 19.1668 21.3331 19.8331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0775 17.3432C20.9149 17.3301 20.7518 17.3301 20.5893 17.3432C20.1231 17.3832 19.6781 17.5563 19.3081 17.8426C18.9375 18.1288 18.6575 18.5157 18.5018 18.9563C18.3781 19.2901 18.3218 19.6445 18.3368 20.0001H11.3506C10.2462 20.0001 9.35056 19.1045 9.35056 18.0001C9.35056 16.8957 10.2462 16.0001 11.3506 16.0001H18.4024C19.1543 16.0045 19.8755 15.7051 20.4038 15.1701C20.7881 14.7851 21.0544 14.2988 21.1719 13.7676C21.2888 13.2363 21.2519 12.6832 21.0656 12.1726C20.8637 11.6251 20.4969 11.1539 20.0156 10.8245C19.5344 10.4945 18.9625 10.3232 18.3794 10.3332H12.6368C12.4631 9.30824 11.5337 8.58697 10.4975 8.6739C9.46128 8.76084 8.66443 9.62702 8.66443 10.667C8.66443 11.7063 9.46131 12.5726 10.4975 12.6595C11.5337 12.747 12.4631 12.0251 12.6368 11.0002H18.3794C19.2906 10.9789 20.1156 11.537 20.4356 12.3902C20.7313 13.192 20.535 14.0927 19.9325 14.699C19.5288 15.1083 18.9775 15.3371 18.4025 15.3333H11.3506C10.3981 15.3333 9.51811 15.8421 9.04118 16.6671C8.56492 17.4921 8.56492 18.5084 9.04118 19.3333C9.51806 20.1583 10.3981 20.6671 11.3506 20.6671H18.4532C18.5751 21.0646 18.7907 21.4265 19.0819 21.7233L20.5957 23.2577H20.5963C20.6588 23.3215 20.7444 23.3571 20.8332 23.3571C20.9225 23.3571 21.0082 23.3215 21.0707 23.2577L22.5844 21.7233C22.9369 21.3665 23.1794 20.9158 23.2825 20.4252C23.385 19.9346 23.3444 19.4246 23.165 18.9564C23.0088 18.5152 22.7288 18.1289 22.3588 17.8427C21.9888 17.5564 21.5438 17.3833 21.0775 17.3433L21.0775 17.3432ZM20.8331 21C20.3612 21 19.9362 20.7156 19.7556 20.28C19.575 19.8438 19.675 19.3419 20.0081 19.0081C20.3418 18.675 20.8437 18.575 21.28 18.7556C21.7156 18.9363 22 19.3613 22 19.8331C21.9993 20.4775 21.4775 20.9994 20.8331 21L20.8331 21Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27051_371105",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#994E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8217"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27051_371105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_27051_371105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteDivert);
export default __webpack_public_path__ + "static/media/route-divert.dca7c8c66cdb03cf7d5180279c94d805.svg";
export { ForwardRef as ReactComponent };